<template>
  <div id="app">
    <router-view :locale="locale" />
  </div>
</template>

<script>
export default {
  name: 'App',
  head: {
    title: {
      inner: '101 Kaikkien Puolesta',
      complement: '101 For All'
    }
  },
  data () {
    return {
      locale: null
    }
  },
  mounted () {
    if (localStorage.locale) {
      this.locale = localStorage.getItem('locale')
    }
  },
  watch: {
    locale: {
      handler () {
        this.$emit('locale', this.locale)
        localStorage.setItem('locale', this.locale)
      },
      deep: true
    }
  },
  methods: {

  }
}
</script>

<style lang="scss">
$column-gap: 0.15rem;
@import '../node_modules/bulma/bulma.sass';
@import '../node_modules/bulma/sass/utilities/initial-variables.sass';
@import 'assets/stylesheets/101.scss';
@import 'assets/stylesheets/pixel2.scss';
@import 'assets/stylesheets/short_landscape.scss';
@import 'assets/stylesheets/ipad.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue